const loaderHandler = {
	data(){
		return{
			loaded: false,
		}
	},
	methods:{
		emitToApp($isBgLight){
			this.$emit('mountedPage', {isBgLight : $isBgLight});
		},
		displayComponent(timeout){
			let self = this;
			setTimeout(function(){
				self.loaded = true;
			},timeout)
		}
	}
}

export default loaderHandler